<template>
    <div>
        <form @submit.prevent="checkAndSubmit($event)" novalidate>

            <div class="row">
                <div class="col-12 mb-4">
                    <h2>{{t('is_the_information_correct')}}</h2>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="form-group form-row">
                        <label for="inputFirstname" class="col-md-2 col-form-label text-left">{{t('profile_firstname')}}*</label>
                        <div class="col-md-10">
                            <input type="text" class="form-control" id="inputFirstname" :placeholder="t('profile_firstname')" v-model="userProvider.firstname" required>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label for="inputLastname" class="col-md-2 col-form-label text-left">{{t('profile_lastname')}}*</label>
                        <div class="col-md-10">
                            <input type="text" class="form-control" id="inputLastname" :placeholder="t('profile_lastname')" v-model="userProvider.lastname" required>
                        </div>
                    </div>

                    <div class="form-group form-row" v-if="requiresSocialSecurityNumber">
                        <label for="inputSSN" class="col-md-2 col-form-label text-left" >{{t('profile_ssn')}}*</label>
                        <div class="col-md-10">
                        <SocialSecurityNumberInput
                                id="inputSSN"
                                v-model="userProvider.national_identification_number"
                                :format-type="userProvider.national_identification_number_type"
                                :language="language"
                                :nationality="userProvider.idCountryNationality"
                                @nationality-change="onNationalityChange"
                                @format-change="onFormatChange"
                                required="false">
                        </SocialSecurityNumberInput>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label for="inputPhone" class="col-12 col-md-2 col-form-label text-left">{{t('profile_phone')}}*</label>

                        <div class="input-group col-3 col-md-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">+</span>
                            </div>
                            <input type="text" class="form-control" id="inputPhonePrefix" :placeholder="t('prefix')" v-model="userProvider.phone_prefix">
                        </div>

                        <div class="col-9 col-md-8">
                            <input type="text" class="form-control" id="inputPhone" @input="removeNonDigitCharacters" :placeholder="t('profile_phone')" v-model="userProvider.phone" required>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <label for="inputCompany" class="col-md-2 col-form-label text-left">{{t('profile_company')}}</label>
                        <div class="col-md-10">
                            <input type="text" class="form-control" id="inputCompany" :placeholder="t('profile_company')"  maxlength="30"  v-model="userProvider.company">
                        </div>
                    </div>


                    <div class="form-group mt-4 form-row">
                        <div class="col-12 col-md-2  col-form-label text-center text-md-left">{{t('delivery_address')}}</div>
                        <div class="col-md-10">

                            <div class="form-group form-row">
                                <div class="col-12 text-left">
                                    <label for="inputAddress" class="text-left">{{t('profile_address')}} 1*<small class="text-muted">({{t('max_30_chars')}})</small></label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="inputAddress" maxlength="30" :placeholder="t('profile_address')" v-model="userProvider.work_address" required>
                                        <div class="input-group-append" v-if="userProvider.work_address">
                                            <span class="input-group-text" v-text="(30 - userProvider.work_address.length) + '/30'"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--                        <div class="input-group-addon" v-text="(30 - userProvider.work_address.length)"></div>-->

                            <div class="form-group form-row">
                                <div class="col-12 text-left">
                                    <label for="inputAddress_2" class="text-left">{{t('profile_address')}} 2 <small class="text-muted">({{t('max_30_chars')}})</small></label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="inputAddress_2"  :placeholder="t('profile_address')" maxlength="30"  v-model="userProvider.work_address_2">
                                        <div class="input-group-append" v-if="userProvider.work_address_2">
                                            <span class="input-group-text" v-text="(30 - userProvider.work_address_2.length) + '/30'"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group form-row">
                                <div class="col-12 text-left">
                                    <label for="inputAddress_3" class="text-left">{{t('profile_address')}} 3 <small class="text-muted">({{t('max_30_chars')}})</small></label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="inputAddress_3"  :placeholder="t('profile_address')" maxlength="30"  v-model="userProvider.work_address_3">
                                        <div class="input-group-append" v-if="userProvider.work_address_3">
                                            <span class="input-group-text" v-text="(30 - userProvider.work_address_3.length) + '/30'"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group form-row">
                                <div class="form-group col-md-8  text-left">
                                    <label for="inputCity" class="text-left">{{t('profile_city')}}*</label>
                                    <input type="text" class="form-control" id="inputCity"  :placeholder="t('profile_zip')" v-model="userProvider.work_city" required>
                                </div>
                                <div class="form-group col-md-4  text-left">
                                    <label for="inputZip" class="text-left">{{t('profile_zip')}}*</label>
                                    <input type="text" class="form-control" id="inputZip"  :placeholder="t('profile_zip')" v-model="userProvider.work_zipcode" required>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="form-row mb-3" v-show="serverFormErrors || clientFormErrors ">
                        <div class="col-12 col-md-2" v-if="notice"></div>
                        <div class="col-12 col-md-10" v-if="notice">
                            <div class="alert alert-info">{{notice}}</div>
                        </div>
                        <div class="col-12 col-md-2"></div>
                        <div class="col-12 col-md-10">
                            <div class="alert alert-danger text-left m-1 pt-1 pb-1" v-for="(error, title) in clientFormErrors" :key="title">
                                    {{ error }}
                            </div>
                            <div class="alert alert-danger text-left" v-for="(error, title) in serverFormErrors" :key="title">
                                <div v-for="errorMessage in error" :key="errorMessage">
                                    {{ errorMessage }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-12 col-md-2"></div>
                        <div class="col-12 col-md-10 text-left">
                            <button class="btn btn-primary mb-5" style="min-width:200px;">{{t('save')}}</button>
                        </div>
                    </div>

                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import SocialSecurityNumberInput from "./SocialSecurityNumberInput";
    export default {
        name: "UserInformationRegistration",
        components: {SocialSecurityNumberInput},
        props: {
            userProvider: {},
            serverFormErrors: null,
            notice: '',
        },
        data: function(){
            return {
                requiresSocialSecurityNumber: false, // Use this to re-enable social security number in form. Disabled for now.
                clientFormErrors: {},
                language : 'en'
            }
        },
        computed: {},
        methods: {
            t : function(key){
                return this.$phrasePlugin.translate(key);
            },
            onFormatChange : function(format){
                this.userProvider.national_identification_number_type = format;
            },
            onNationalityChange : function(id){
                this.userProvider.idCountryNationality = id || null;
            },
            setLanguageId : function(idLanguage){
              this.$phrasePlugin.setLanguageId(idLanguage);
            },
            removeNonDigitCharacters: function() {
                this.userProvider.phone = this.userProvider.phone || '';
                this.userProvider.phone = this.userProvider.phone.replace(/[^0-9]+/g, '');
            },
            checkAndSubmit: function() {
                this.clientFormErrors = {};
                let isErrorsEmpty = true;
                let requiredFields = [
                    {
                        field : 'firstname',
                        title: 'profile_firstname',
                        type : 'string'
                    },{
                        field : 'lastname',
                        title: 'profile_lastname',
                        type : 'string'
                    },{
                        field : 'phone',
                        title: 'profile_phone',
                        type : 'string'
                    },{
                        field : 'work_address',
                        title: 'profile_address',
                        type : 'string'
                    },{
                        field : 'work_city',
                        title: 'profile_city',
                        type : 'string'
                    },{
                        field : 'work_zipcode',
                        title: 'profile_zip',
                        type : 'string'
                    },
                ];

                if(this.requiresSocialSecurityNumber){
                  requiredFields.push({
                    field : 'national_identification_number',
                    title: 'profile_ssn',
                    type : 'number'
                  });
                }

                requiredFields.forEach(function(item){
                    if(item.field === 'phone'){
                        if (!this.userProvider[item.field] || !parseInt(this.userProvider[item.field])) {
                            isErrorsEmpty = false;
                            this.clientFormErrors[item.field] = this.t(item.title) + ' ' + this.t('mandatory').toLowerCase();
                        }
                    } else if (!this.userProvider[item.field]) {
                        isErrorsEmpty = false;
                        this.clientFormErrors[item.field] = this.t(item.title) + ' ' + this.t('mandatory').toLowerCase();
                    }
                }, this);

                if((this.userProvider["work_address"] && this.userProvider["work_address"].length > 30) || this.userProvider["work_address_2"] && this.userProvider["work_address_2"].length > 30 || this.userProvider["work_address_3"] && this.userProvider["work_address_3"].length > 30){
                    isErrorsEmpty = false;
                    this.clientFormErrors["work_address"] = this.t('address_field_length_error');
                }


                if(isErrorsEmpty){
                      this.$emit('save');
                }
            }
        },
        created(){
            // Set the id language locally on the component whenever the phrase plugin changes language.
            this.language = this.$phrasePlugin.getLanguageId();
            this.$phrasePlugin.$on('language-change', (id_language) => {
                this.language = id_language;
            });
        }
    }
</script>

<style scoped>

</style>